import { Component, Input, OnInit } from '@angular/core';
import { ConfigServiceProvider } from '../../../modules/core/services/config-service/config-service';
import { KpiDefinition } from '../../../modules/ranking/interfaces/kpi-definition';
import { KpiHistory, RankingDefinition } from '../../../modules/ranking/services/ranking-service/ranking-definition';
import { KpiServiceProvider } from '../../../modules/ranking/services/kpi-service/kpi-service';
import { MapOfNumberTo, Utils } from '../../../modules/ranking/interfaces/utils';
import { PlayerServiceProvider } from '../../../modules/core/services/player-service/player-service';
import { RankingServiceProvider } from '../../../modules/ranking/services/ranking-service/ranking-service';
import { RankingWithKpiMapAndExtras } from '../../../modules/ranking/services/ranking-service/ranking.interface';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';
import { User } from '../../../modules/core/services/users-service/interfaces/user.interface';

// todo: refactor
@Component({
  selector: 'ranking-comparision',
  templateUrl: 'ranking-comparision.html',
})
export class RankingComparisionComponent implements OnInit {
  filters = { ranking: 0, user: null };
  rankingDefinition: RankingDefinition = {} as RankingDefinition;
  ranking: MapOfNumberTo<RankingWithKpiMapAndExtras[]> = {};
  kpiDefinitions: KpiDefinition[] = [];
  kpiDefinitionsById: MapOfNumberTo<KpiDefinition>;
  player: User;
  currentKpis: KpiHistory;
  loading: boolean = true;

  @Input() filterRanking: number;
  @Input() filterUser: number;
  @Input() opponentUser: User;
  @Input() displayPointDifference: boolean = true;

  constructor(
    public configService: ConfigServiceProvider,
    public textService: TextServiceProvider,
    private kpiService: KpiServiceProvider,
    private playerService: PlayerServiceProvider,
    private rankingService: RankingServiceProvider,
  ) {}

  ngOnInit() {
    this.filters.ranking = this.filterRanking;
    this.filters.user = this.filterUser;
    this.loading = true;

    Promise.all([
      this.playerService.getPlayer(),
      this.kpiService.getKpiDefinitions(),
      this.rankingService.getRankingDefinitions(),
      this.rankingService.getRankings(),
    ]).then(([player, kpiDefinitions, rankingDefinitions, rankings]) => {
      this.player = player;
      this.kpiDefinitions = kpiDefinitions;
      this.kpiDefinitionsById = Utils.toMapByNumeric(this.kpiDefinitions, 'id');
      this.rankingDefinition = this.getRankingById(this.filters.ranking, rankingDefinitions);
      this.ranking = rankings[this.filters.ranking];

      let currentRanking = this.ranking[this.player.id];
      if (!currentRanking) {
        currentRanking = this.ranking[this.opponentUser.id];
      }

      let rankingDate = new Date(currentRanking[0].date);

      let kpisHistory = this.rankingDefinition.params.kpis.sort((a, b) => {
        if (new Date(a.date_start).getTime() > new Date(b.date_start).getTime()) {
          return -1;
        } else if (new Date(a.date_start).getTime() < new Date(b.date_start).getTime()) {
          return 1;
        } else {
          return 0;
        }
      });

      this.currentKpis = {
        kpi: [],
      } as KpiHistory;
      for (let j = 0; j < kpisHistory.length; j++) {
        if (new Date(kpisHistory[j].date_start).getTime() <= new Date(rankingDate).getTime()) {
          this.currentKpis = kpisHistory[j];
          break;
        }
      }

      this.currentKpis.kpi.sort((a, b) => Utils.compareKpisByPriorityDescendingThenMultiplierDescending(a, b, this.kpiDefinitionsById));

      setTimeout(() => {
        this.loading = false;
      }, 350);
    });
  }

  getRankingById(id, rankingDefinitions: RankingDefinition[]): RankingDefinition {
    for (let i = 0; i < rankingDefinitions.length; i++) {
      if (rankingDefinitions[i].id == id) {
        return rankingDefinitions[i];
      }
    }
    return null;
  }

  getKpiById(id: number) {
    return this.kpiDefinitionsById[id];
  }

  getPointDifference(kpiId: number, id1: number, id2: number): number {
    return Math.round(this.getRankingValue(id1, kpiId)) - Math.round(this.getRankingValue(id2, kpiId));
  }

  getRankingValue(participantId: number, kpiId: number): number {
    if (!this.ranking[participantId]) {
      return 0;
    }
    if (!this.ranking[participantId][0].params.kpis[kpiId]) {
      return 0;
    }

    return this.ranking[participantId][0].params.kpis[kpiId].params.value || 0;
  }

  areParticipantsComparable() {
    return this.ranking[this.player.id] && this.player.id !== this.opponentUser.id
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ranking-comparision/ranking-comparision.ts